export default "__VITE_ASSET__22d21d7f__"